"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumbersInList = exports.getMinimumValue = exports.getMaximumValue = void 0;
const validations_1 = require("./validations");
function getMaximumValue(...values) {
    const numbers = getNumbersInList(values);
    if (numbers.length === 0) {
        return undefined;
    }
    return Math.max(...numbers);
}
exports.getMaximumValue = getMaximumValue;
function getMinimumValue(...values) {
    const numbers = getNumbersInList(values);
    if (numbers.length === 0) {
        return undefined;
    }
    return Math.min(...numbers);
}
exports.getMinimumValue = getMinimumValue;
function getNumbersInList(values) {
    return values.filter(val => (0, validations_1.isNumber)(val));
}
exports.getNumbersInList = getNumbersInList;
